import React from "react";
import { Palette, Server, Globe, FileText, Smartphone, TrendingUp, Mail, Phone, RefreshCw, Headset, PenTool, FilePen } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Custom Modern Design",
  description: "A professional, unique website design tailored to your brand identity, not a generic template.",
  icon: Palette
}, {
  title: "12 Months Hosting",
  description: "Secure, high-speed hosting included for the first year to keep your site online and fast.",
  icon: Server
}, {
  title: "Free Domain Registration",
  description: "We handle the registration of your .com.au or .com domain name for the first 12 months.",
  icon: Globe
}, {
  title: "Up to 3 Pages",
  description: "Essential pages like Home, Services, and Contact designed to convert visitors into customers.",
  icon: FileText
}, {
  title: "Mobile Responsive",
  description: "Your site will look and work perfectly on all devices, from desktop computers to smartphones.",
  icon: Smartphone
}, {
  title: "Basic SEO Optimisation",
  description: "On-page SEO setup to help your business get found on Google by local customers.",
  icon: TrendingUp
}, {
  title: "Contact Form Integration",
  description: "A custom contact form that sends inquiries directly to your email for easy lead management.",
  icon: Mail
}, {
  title: "Click-to-Call Buttons",
  description: "Prominent call buttons that allow mobile users to dial your number with a single tap.",
  icon: Phone
}, {
  title: "Ongoing Updates",
  description: "Includes 2 content changes per month to keep your information current and relevant.",
  icon: RefreshCw
}, {
  title: "Unlimited Tech Support",
  description: "Direct access to our Australian team for any technical questions or issues you encounter.",
  icon: Headset
}, {
  title: "2 Design Revisions",
  description: "Two rounds of design feedback to ensure the visual style matches your vision perfectly.",
  icon: PenTool
}, {
  title: "Content Revisions",
  description: "One round of content refinement to polish your text and ensure your message is clear.",
  icon: FilePen
}];
export default function PackageFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="package-features" className="bg-background text-foreground py-20 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight">
            Everything You Need to <span className="text-primary">Get Started</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Our Starter Package is packed with premium features designed to establish your professional online presence and drive growth.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {features.map((feature, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full bg-card border-border/50 hover:border-primary/50 hover:shadow-[0_10px_40px_-15px_rgba(61,193,188,0.2)] transition-all duration-300 group overflow-hidden">
                <CardHeader className="pb-2">
                  <div className="mb-4 inline-flex items-center justify-center p-3 rounded-full bg-primary text-primary-foreground w-fit shadow-lg shadow-primary/20 group-hover:scale-110 transition-transform duration-300">
                    <feature.icon className="size-6" />
                  </div>
                  <CardTitle className="text-xl font-bold group-hover:text-primary transition-colors duration-300">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
                {}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/0 to-transparent group-hover:via-primary/50 transition-all duration-500" />
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}